// removed by extract-text-webpack-plugin
module.exports = {"view":"view__2AS8D","header":"header__w6rXG","inner":"inner__3fKQn","text":"text__2Cl08","contact":"contact__2mnkk","contactForm":"contactForm__3Ui3j","iframe":"iframe__jwCrJ","row":"row__5YGYg","button":"button__37-iw","message":"message__120ab","error":"error__ED-Bu","show":"show__3JL6n","sent":"sent__6Nxeq","textImage":"textImage__3GcWn","content":"content__3VcNj","right":"right__2Rf8K","iframeWindow":"iframeWindow__127lT","leftAligned":"leftAligned___-L8j","rightAligned":"rightAligned__20q9p","centerAligned":"centerAligned__vP50F"};


//////////////////
// WEBPACK FOOTER
// ./routes/generic-page.sass
// module id = vyX1
// module chunks = 0 10